/**
 * Objet permettant de vérifier la taille de l'écran et d'appliquer des media queries
 *
 * Adapté de: https://www.geeksforgeeks.org/how-to-use-media-queries-with-javascript/
 *
 * @export
 * @class MediaQuery
 */
export default class MediaQuery {
    // Objets MediaQueryList permettant de vérifier la taille de l'écran
    tablette;
    desktop;
    nbSlidesTablette;
    nbSlidesDesktop;
    /**
     * Créer un instance de MediaQuery
     *
     * @memberof MediaQuery
     */
    constructor(nbSlidesDesktop = 4) {
        // Instancier les membres
        this.tablette = window.matchMedia('(min-width: 678px)');
        this.desktop = window.matchMedia('(min-width: 1280px)');
        this.nbSlidesTablette = 2; // 2 slides par défaut sur tablette
        this.nbSlidesDesktop = nbSlidesDesktop; // 4 slides par défaut sur desktop
        // Mettre ses écouteurs
        this.ajouterListeners();
    }
    handleScreenChange() {
        let code = 1; // Valeur de retour par défaut (écrans mobiles)
        if (this.desktop.matches) {
            // Valeur de retour pour les écrans "desktop"
            code = this.nbSlidesDesktop;
        }
        else if (this.tablette.matches) {
            // Valeur pour les écrans "tablette"
            code = this.nbSlidesTablette;
        }
        return code;
    }
    ajouterListeners() {
        this.tablette.addEventListener('change', this.handleScreenChange);
        this.desktop.addEventListener('change', this.handleScreenChange);
    }
}
